import { BetManager, Bus } from '@atlas/core';

const addBetBoosterWindowFunctions = () => {
  window.selectOutcome = ({ betGroups, eventId, marketId, marketTypeId, outcomeId }) => {
    BetManager.selectBet({
      eventId,
      marketTypeId,
      marketId,
      outcomeId,
      betGroups,
    });
  };

  // This function could be used in the future but has no use right now
  // I've left it here as an example because the bet booster has no documentation about it
  window.onInsightsCountChanged = (homeName, awayName, insightsCount) => {
    Bus.emit('insightsCountChanged', {
      homeName,
      awayName,
      insightsCount,
    });
  };
};

export default addBetBoosterWindowFunctions;
